import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import NavigationUI from './ui/NavigationUI';

const Navigation = ({ location, account }) => (
  <NavigationUI location={location} account={account} />
);

const mapStateToProps = (state) => {
  return {
    account: state.web3.accounts[0],
  };
};

export default connect(mapStateToProps)(withRouter(Navigation));



// WEBPACK FOOTER //
// ./src/components/Navigation.js